import React from 'react'

import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import PsPenetapanIndex from 'app/KinerjaPSPage/pages/penetapan/Index'
import PageGuardPengawas from 'app/KinerjaPSPage/components/PageGuardPengawas'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'
import { PageGuardPenetapan } from 'app/KinerjaPSPage/components/PageGuardPenetapan'

import type { KinerjaApp } from 'types/kinerja-layout'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export type allowedTujuan = 'kepala-sekolah' | 'kepala-dinas'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const enabled =
      (toggle?.['kinerja-ps-enabled'] &&
        toggle?.['kinerja-ps-penetapan-enabled']) ||
      false

    if (!enabled) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }
  },
})

const Page: KinerjaApp = () => {
  return (
    <PageGuardPengawas accessibleByKepalaDinas>
      <PageGuardPenetapan>
        <PsPenetapanIndex />
      </PageGuardPenetapan>
    </PageGuardPengawas>
  )
}

Page.Layout = KinerjaLayout

Page.layoutOpts = {
  hasHeader: true,
  centered: true,
}

export default Page
